import $http from '../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Cargar las listas.
 *
 * @param {*} commit
 * @param Integer idControl: id del control para consultar las listas (0=carga todas las listas).
 * @return {Promise<void>}
 * @author Fernando CLaros Garcia
 */
export async function loadLists({ commit }, idControl) {
  commit('dashboard/load', true, { root: true });

  await $http.get(`sys_list/the-language-lists/by-control/${idControl}`)
    .then(({ data: response, status }) => {

      if (status === 200) {
        commit('setLists', response.payload);
        return;
      }

      callbackGenerateAlert('info', response.message, true);
    })
    .catch(() => callbackGenerateAlert('error', 'Error al tratar de cargar las Listas de idiomas.'))
    .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Generar alarta.
 *
 * @param String icon: (info, success, error)
 * @param String text
 * @param Boolean showConfirmButton
 * @author Fernando CLaros Garcia
 */
function callbackGenerateAlert(icon = 'info', text = '', showConfirmButton = false) {
  Swal.fire({
    position: 'center',
    icon,
    title: 'Variables configurables',
    text,
    showConfirmButton
  })
}


/**
 * Obtener la lista y él id por nombre.
 *
 * @param {*} commit
 * @param name criterio de busqueda
 * @returns {Promise<boolean>}
 * @author Paul Valencia
 */
export async function getIdListdByName({ commit }, name) {
    commit('dashboard/load', true, { root: true });
    await $http.get("sys_list/list-by-name", {params: {name}})
        .then(({ data: response }) => commit('setSysList', response.data))
        .catch((error) => {
            if (this.$vue.$alertErrorsCallback(error)) return;
            this.$vue.$alertError(error.message,5000);
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}
